import { Component, OnInit, ViewChild, Renderer2, HostListener, AfterViewInit, Output, ElementRef, ChangeDetectorRef, TemplateRef } from '@angular/core';
import * as d3 from 'd3';
import { PanZoomConfig, PanZoomAPI, PanZoomModel } from 'ngx-panzoom';
import { Subscription } from 'rxjs';
import cloneDeep from 'lodash.clonedeep';
import { AppConstants, hasPrivilege } from '../../../shared/app-constants';
import { PngToSvgService } from './service/png-to-svg.service';
import { LutServiceService } from './service/lut-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MaskingService } from './service/masking.service';
import { SvgtopngService } from './service/svgtopng.service';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { CameraServerService } from '../../camera-server.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-mask-cams',
  templateUrl: './mask-cams.component.html',
  styleUrls: ['./mask-cams.component.scss']
,
  standalone: false
})
export class MaskCamsComponent implements OnInit, AfterViewInit {
  public gitImage: string;
  public imageName: string;
  public dragging = false;
  public drawing = false;
  public startPoint = [];
  public svg: any;
  public g: any;
  public isCollapsed = false;
  public points = [];
  public loadedColors: number;
  public color = '#402020';
  public colorIndex = 0;
  public history = [];
  public providedURL: string;
  public customMaskURL: string;
  public svgElement: any;
  panzoomConfig: PanZoomConfig = new PanZoomConfig({
    zoomLevels: 1,
    scalePerZoomLevel: 1,
    zoomStepDuration: 0.2,
    freeMouseWheel: false,
    invertMouseWheel: true,
    zoomToFitZoomLevelFactor: 0.9,
    dragMouseButton: 'right',
    initialZoomLevel: 1
  });
  private panZoomAPI: PanZoomAPI;
  public panzoomModel: PanZoomModel;
  private apiSubscription: Subscription;
  private modelChangedSubscription: Subscription;
  public layers: any;
  public loadedMask = false;
  public layerPoints = [];
  public localStorage = [];
  public previewShown = false;
  @ViewChild('artboard', { static: false }) artboard: ElementRef;
  public opacity: number = 100;
  @ViewChild('imageNumber') imageNumber;
  @ViewChild('url', { static: false }) url;
  @Output() Layers;
  cam: any = null
  site: any = null
  bgUrl: any;
  camserData: any;
  showMessage: boolean = false;
  intimationMessage: string;
  showBtn: boolean = false;
  status: string;
  getImageHeight: any;
  getImageWidth: any;
  setDynamicImgHeight: any;
  setDynamicImgWidth: any;
  actionTableWidth: any;
  userName: any;
  email: any;
  blobUrl: any;
  maskWindow: Window | null = null;
  imageWindow: Window | null = null;
  hasEditPrivilege: boolean = false;
  pointsFromCamera: any;
  isAnalyticIdSeven: any;
  camUniqueIdToChange: any;
  modalRef: NgbModalRef;
  @ViewChild('changeMaskingModal') changeMaskingModal!: TemplateRef<any>;
  @ViewChild('removeMaskingModalRef') removeMaskingModalRef! : TemplateRef<any>;

  removeMask:boolean = false;
  resolutions: any;
  isResolution720p: any;

  constructor(
    private router: Router,
    private renderer: Renderer2,
    private pngToSvg: PngToSvgService,
    private lut: LutServiceService,
    public spinner: SpinnerService,
    private activatedRoute: ActivatedRoute,
    private maskSvc: MaskingService,
    private svgToPng: SvgtopngService,
    public restService: CameraServerService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private toast: ToastrService,
    public cameraService: CameraServerService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {
    // this.cam = this.router.getCurrentNavigation().extras.state.cam;
    // this.site = this.router.getCurrentNavigation().extras.state.site;
    // this.camserData = this.router.getCurrentNavigation().extras.state.camServer;
    // this.getImageHeight = this.router.getCurrentNavigation().extras.state.ImageHeight;
    // this.getImageWidth = this.router.getCurrentNavigation().extras.state.ImageWidth;
    this.cam = JSON.parse(sessionStorage.getItem('camdetails'))?.cam;
    this.site = JSON.parse(sessionStorage.getItem('camdetails'))?.site;
    this.camserData = JSON.parse(sessionStorage.getItem('camdetails'))?.camServer;
    this.getImageHeight = JSON.parse(sessionStorage.getItem('camdetails'))?.ImageHeight;
    this.getImageWidth = JSON.parse(sessionStorage.getItem('camdetails'))?.ImageWidth;
    this.pointsFromCamera = JSON.parse(sessionStorage.getItem('camdetails'))?.Points_From_Camera;
    this.isAnalyticIdSeven = JSON.parse(sessionStorage.getItem('camdetails'))?.AnalyticIdSeven;
    if (hasPrivilege('edit camera configuration')) {
      this.hasEditPrivilege = true;
    }
    this.checkResolution();
  }

  ngOnInit(): void {
    const storage = Object.entries(localStorage);
    // for (const item of storage) {
    //     if (item[0].includes('github')) {
    //         item[0] = item[0].match(/[\w-]+\.(png|jpg)/)[0].substring(0, 4);
    //         this.localStorage.push(item);
    //     }
    // }
    this.apiSubscription = this.panzoomConfig.api.subscribe((api: PanZoomAPI) => this.panZoomAPI = api);
    this.modelChangedSubscription = this.panzoomConfig.modelChanged.subscribe((model: PanZoomModel) => {
      this.onModelChanged(model);
      this.panzoomModel = model;
    });
    if (this.cam["resolution"] == '1280x720') {
      this.setDynamicImgHeight = this.getImageHeight;
      this.setDynamicImgWidth = this.getImageWidth;
      if (parseInt(this.getImageWidth) > 1400) {
        let convertVal = parseInt(this.getImageWidth);
        this.actionTableWidth = convertVal + 80;
        if (parseInt(this.getImageWidth) > 1900) {
          this.setDynamicImgWidth = convertVal + 100;
        }
      } else {
        this.actionTableWidth = '1330';
      }
      this.svg = d3.select('.artboard').append('svg')
        .attr('width', this.getImageWidth)
        .attr('height', this.getImageHeight);
    }

    if (this.cam["resolution"] == '480x360') {
      this.setDynamicImgHeight = '590';
      this.setDynamicImgWidth = '1800';
      this.actionTableWidth = '1330';
      this.svg = d3.select('.artboard').append('svg')
        .attr('width', this.cam["resolution.width"])
        .attr('height', this.cam["resolution.height"])
    }

    this.spinner.activate();
    const urls = "mengine/admin/masking/getimage";
    this.restService.BlobImage(this.cam, this.site, urls).subscribe((response: any) => {
      this.spinner.deactivate();
      let buffer = Buffer.from(response, 'binary').toString('base64');
      const base64Image = `data:image/jpg;base64,${buffer}`; // You may need to adjust the content type if not JPEG
      this.svg.style('background-image', `url('${base64Image}')`);
      if (this.cam["resolution"] == '480x360') {
        this.intimationMessage = 'SD masking should be done on Camera server and it takes 24 hours to reflect here.';
        this.showMessage = true;
        this.showBtn = false;
      } else {
        this.intimationMessage = 'Masking should be drawn in Camera server.';
        this.showMessage = true;
        this.showBtn = true;
      }
      // else if (this.site.analyticId == 7 && this.cam["resolution"] == '1280x720') {
      //   this.intimationMessage = 'masking for AID7 cameras masking should be drawn in Camera and unified masking';
      //   this.showMessage = true;
      //   this.showBtn = true;
      // } else if (this.site.analyticId == 10 || this.site.analyticId == 11 || this.site.analyticId == 12 && this.cam["resolution"] == '1280x720') {
      //   this.intimationMessage = 'Media Engine HD masking for AID10,AID11 and AID12 should be done on Media Engine and it will take 24 hours to reflect here.';
      //   this.showMessage = true;
      // }
      this.addLayer();
    }, (err) => {
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toast.error(err.error.message, 'Error');
      } else {
        this.toast.error(AppConstants.defaultErrorMessage, 'Error');
      }
    });

    this.activatedRoute.queryParams.subscribe(params => {
      const userId = params.userId;
    });

    this.maskSvc.getImageUrl().subscribe(url => {
      this.svg.style('background-image', `url('${url}')`);
    })

    // this.maskSvc.getMaskUrl().subscribe(url => {
    //     this.loadedMask = true;
    //     this.svg.selectAll('.existingMask').remove();
    //     const g = this.svg.append('g').attr('class', 'existingMask' + ' completePoly').attr('layerHidden', 'false')
    //         .attr('color', 'existingMask')
    //         .attr('opacity', this.opacity)
    //         .attr('visibility', 'visible');
    //     g.append('svg:image')
    //         .attr('href', url)
    //         .attr('x', 43)
    //         .attr('y', 38);
    // })

    this.maskSvc.getLayerChange().subscribe(obj => {
      if (obj.type === 'opacity') {
        this.svg.selectAll('.completePoly').attr('opacity', obj.index * .01);
        this.opacity = obj.index * .01;
      }
      if (this.previewShown) {
        return;
      }
      if (obj.type === 'delete') {
        this.deleteLayer(obj.index);
      }
      if (obj.type === 'up') {
        this.toFront(obj.index);
      }
      if (obj.type === 'down') {
        this.toBottom(obj.index);
      }
      if (obj.type === 'toggle') {
        this.toggleVisibility(obj.index);
      }
      if (obj.type === 'clearAll') {
        this.deleteAllLayers();
      }
      if (obj.type === 'revert') {
        this.revertFromLocalStorage(obj.collection);
      }
      if (obj.type === 'toggleAll') {
        this.toggleAll();
      }
      if (obj.type === 'addToLocalStorage') {
        this.addToLocalStorage();
      }
      if (AppConstants.colors.map(e => e.color).includes(obj.type)) {
        this.updateColor(obj.index, obj.type);
      }
      this.setLayers();
    })
  }
  checkResolution() {
    this.resolutions = JSON.parse(sessionStorage.getItem('camdetails'))?.resolutions || '';
    if (this.resolutions === '720p/1080p/4k/8k') {
      this.isResolution720p = true;  
    } else {
      this.isResolution720p = false; 
    }
  }

  // ngOnDestroy(): void {
  //   this.apiSubscription.unsubscribe();  // don't forget to unsubscribe.  you don't want a memory leak!
  // }

  ngAfterViewInit(): void {
    this.maskSvc.setArtboard(this.artboard.nativeElement.innerHTML);
    this.setLayers();
    this.svgElement = this.artboard.nativeElement.children[0];
    this.cdr.detectChanges();
  }

  public deleteSpLayer(layer): void {
    layer.remove();
  }

  /** Darw masking image */
  public save(): void {
    if(this.pointsFromCamera){
      return;
    } else {
      let layers = this.svgElement.children;
      if (layers != null) {
        let maskOutArray = [];
        for (let layer of layers) {
          let csv = layer.children[0].getAttribute('points');
          let csvArray = csv.split(",")
          if (csvArray.length % 2 == 0) {
            //right array
            let allArray = [];
            let coords = [];
            for (let point of csvArray) {
              coords.push(point)
              if (coords.length == 2) {
                allArray.push(coords);
                coords = [];
              }
            }
            let polyJson = this.polyPointsPerLayer(allArray);
            maskOutArray.push(polyJson);
          }
        }
        let maskData = this.cam.maskingData;
        if (maskData == null || maskData == "") {
          let maskDataStr = '{"eventDetection":{"motionDetection":false,"tripWire":false,"maskIn":false},"sensitivity":6,"bgs":3,"maskInList":[],"maskOutList":[],"tripWireList":[],"sensitivityList":[]}'
          maskData = JSON.parse(maskDataStr);
        }
        //let maskData = JSON.parse(maskDataStr);
        maskData.maskOutList = maskOutArray;
        this.cam.maskingData = maskData;
        // this.cam.maskingData = JSON.stringify(maskData);
        //alert("maskingData: "+ this.cam.maskingData);
        this.saveInDb();
      }
    }
  }

  //commented existing conversion code
  /*
  private polyPointsPerLayer(allArray: any): any {
    let polyArray = [];
    for (let point of allArray) {
      let polyCords = {
        "x": ((point[0] * 480) / this.getImageWidth),
        "y": ((point[1] * 360) / this.getImageHeight),
      }
      polyArray.push(polyCords);
    }
    return { "polygonPoints": polyArray };
  }
  */

  /* Without conversion code below */
  private polyPointsPerLayer(allArray) {
    let polyArray = [];
    for (let key in allArray) {
      let pair = allArray[key];
      let x = parseInt(pair[0]);
      let y = parseInt(pair[1]);
      polyArray.push({ "x": x, "y": y });
    }
    return { "polygonPoints": polyArray };
  }

  private saveInDb(): void {
    this.userName = JSON.parse(localStorage.getItem('currentUser') || '{}')
    this.email = this.userName.email;
    var req = {}
    req["cameraUniqueId"] = this.cam["camUniqueId"];
    req["potentialId"] = this.cam["potentialId"];
    req["cameraId"] = this.cam["camUniqueId"];
    req["resolution"] = this.cam["resolution"];
    req["masking_data"] = this.cam.maskingData;
    req["lastModifiedBy"] = this.email;
    this.spinner.activate();
    this.restService.saveUpdateMasking(req).subscribe((res: any) => {
      this.status = res.status;
      this.spinner.deactivate();
      this.refreshBgImage();
      this.toast.success("Masking saved successfully!");
    }, (err) => {
      this.spinner.deactivate();
      this.toast.error(AppConstants.defaultErrorMessage);
    });
  }

  // private saveInDb(): void {
  //   var self = this;
  //   var req = {}
  // //    console.log("self.cam for saveInDb--" + this.saveCount + "---" + JSON.parse(self.cam.maskingData).maskOutList.length);
  //   let site_req = {"potentialId":self.site.potentialId, "cams":[self.cam]}
  //   req["site"] = site_req;
  //   req["actionType"] = "UPDATE_MASKING";
  //   console.log("site: ", req);
  //   self.spinner.activate();
  //   self.restService.postRequest(AppSettings.UPDATE_SITE_DATA, req).subscribe((res: any) => {
  //      self.spinner.deactivate();
  //      console.log("res.data ", res.data)
  //      //if not installed - prompt to install it.
  //      if(res.data != null){
  //           console.log("Already Installed..")
  //           this.bgUrl = "https://scdn.pro-vigil.info/api/pro/" + this.site.potentialId + "/snaps/imgdata/" + this.cam["camUniqueId"] + ".jpg?" + new Date().getTime();
  //           this.refreshBgImage();
  //       }
  //   });
  // }

  public reloadImage(): void {
    this.status = '';
    var reqParam = {}
    this.spinner.activate();
    this.restService.getMasking(this.cam, reqParam).subscribe((res: any) => {
      this.spinner.deactivate();
      /** This is old code as per backend removing res.data.masking_data != null check */
      /** if (res.data != null && res.data.masking_data != null) {
        let maskData = res.data.masking_data;
        this.cam.maskingData = JSON.parse(maskData);
        this.refreshBgImage();
      } else {
        this.cam.maskingData = [];
      } */
      if (res.data != null) {
        let maskData = res.data.masking_data;
        this.cam.maskingData = JSON.parse(maskData);
        this.refreshBgImage();
      } else {
        this.cam.maskingData = [];
      }
    });
  }

  public refreshBgImage(): void {
    this.spinner.activate();
    const urls = "mengine/admin/masking/getimage";
    this.restService.BlobImage(this.cam, this.site, urls).subscribe((response: any) => {
      this.spinner.deactivate();
      let buffer = Buffer.from(response, 'binary').toString('base64');
      const base64Image = `data:image/jpg;base64,${buffer}`; // You may need to adjust the content type if not JPEG
      this.svg.style('background-image', `url('${base64Image}')`);

      if (this.status == 'success') {
        if (this.cam["resolution"] == '480x360') {
          this.dialog.open(ConfirmationDialogComponent, {
            width: '50%',
            data: {
              message: 'Please draw the same masking in Camera Server (SD) to have updated masking'
            }
          });
        } else if (this.site.analyticId == 7 && this.cam["resolution"] == '1280x720') {
          this.dialog.open(ConfirmationDialogComponent, {
            width: '50%',
            data: {
              message: 'Please draw the same masking in Axis Camera (HD) to have updated masking at all places'
            }
          });
        } else if (this.site.analyticId == 10 || this.site.analyticId == 11 || this.site.analyticId == 12 && this.cam["resolution"] == '1280x720') {
          this.dialog.open(ConfirmationDialogComponent, {
            width: '50%',
            data: {
              message: 'Please draw the same masking in Media Engine Application (HD) to have updated masking'
            }
          });
        }
      }

    })
  }

  public showMask(): void {
    this.spinner.activate();
    const urls = "mengine/admin/masking/getlivemask";
    this.restService.BlobImage(this.cam, this.site, urls).subscribe((response: any) => {
      this.spinner.deactivate();
      let blob: any = new Blob([response], { type: 'image/bmp' });
      this.blobUrl = window.URL.createObjectURL(blob);
      //saveAs(blob, filename + '.' + format);
      this.maskWindow = window.open(this.blobUrl, "_maskWindow");
    }, (err) => {
      this.spinner.deactivate();
      this.toast.error(AppConstants.defaultErrorMessage);
    })
  }

  public showImage(): void {
    this.spinner.activate();
    var baseUrl = "mengine/admin/masking/getliveimage";
    this.restService.BlobImage(this.cam, this.site, baseUrl).subscribe((res: any) => {
      this.spinner.deactivate();
      let blob: any = new Blob([res], { type: 'image/bmp' });
      // const url = window.URL.createObjectURL(blob);
      //saveAs(blob, filename + '.' + format);
      // this.imageWindow = window.open(url, "_imageWindow");
      this.reloadImage();
    }, (err) => {
      this.spinner.deactivate();
      this.toast.error(AppConstants.defaultErrorMessage);
    });
  }

  public highlightSpLayer(layer): void {
    let currColor = layer.children[0].getAttribute('style')
    let fColor = "#402020"
    if (!currColor.includes("#00ff66")) {
      fColor = "#00ff66"
    }
    layer.children[0].setAttribute('style', 'fill: ' + fColor + ';');
  }

  private addLayer(): void {
    let maskData = this.cam.maskingData;
    if (maskData != null && maskData.maskOutList != null) {
      for (let maskObj of maskData.maskOutList) {
        let polyObjArray = maskObj.polygonPoints;
        if(this.pointsFromCamera){
          polyObjArray.splice(-5);
        }
        if (polyObjArray != null) {
          let points = []
          for (let polyObj of polyObjArray) {
            if (this.camserData == true) {
              points.push([(polyObj.x), (polyObj.y)]);
            } else {
              //points.push([(this.getImageWidth*polyObj.x/480), (this.getImageHeight*polyObj.y/360)]);   
              // points.push([(1280*polyObj.x/480), (720*polyObj.y/360)]);  
              points.push([(polyObj.x), (polyObj.y)]); //direct showing without conversion points 
            }
          }
          // Check if points_From_Camera is true
          if (this.pointsFromCamera && points.length > 0) {
            let invertedPoints = this.invertPolygon(points); // this line need to stop execute
            this.addLayerByPoints(invertedPoints);
          } else if (points.length > 0) {
            // Directly add points without inversion
            this.addLayerByPoints(points);
          }
        }
      }
    }
  }
  private invertPolygon(polygonPoints: number[][]): number[][] {
    const canvasWidth = this.getImageWidth;
    const canvasHeight = this.getImageHeight;
    const boundingBox = [
      [0, 0],
      [canvasWidth, 0],
      [canvasWidth, canvasHeight],
      [0, canvasHeight],
      [0, 0],
    ];
    return [
      ...boundingBox,
      ...polygonPoints.slice().reverse(),
      polygonPoints[0],
    ];
  }

  private addLayerByPoints(newPts): void {
    let child = ' child';
    this.svg.selectAll('circle').attr('cursor', 'move');
    this.svg.select('g.drawPoly').remove();
    const g = this.svg.append('g').attr('class', this.maskSvc.currentColor.color + ' completePoly' + child).attr('layerHidden', 'false')
      .attr('color', this.maskSvc.currentColor.color)
      .attr('opacity', this.opacity)
      .attr('visibility', 'visible');
    g.append('polygon')
      .attr('points', newPts)
      .attr('shape-rendering', 'crispEdges')
      .style('fill', this.maskSvc.currentColor.color);
    for (const point of newPts) {
      const holder = this;
      g.selectAll('circles')
        .data([point])
        .enter()
        .append('circle')
        .attr('cx', point[0])
        .attr('cy', point[1])
        .attr('r', 4)
        .attr('stroke-width', 1)
        .attr('fill', '#FDBC07')
        .attr('stroke', '#000')
        .attr('is-handle', 'true')
        .attr('class', 'dragCircle')
        .attr('cursor', 'move')
        .call(d3.drag()
          .on('drag', function () {
            holder.handleDrag(this);
          })
          .on('end', () => {
            this.dragging = false;
            this.addToHistory(this.drawing, this.startPoint, this.g, newPts);
          })
        );

    }

  }
  private setLayers(): void {
    this.maskSvc.updateMask({ d3: this.svg, dom: this.artboard.nativeElement, loadedMask: this.loadedMask });
  }

  private deleteLayerClick(e): void {
    if (e.target.tagName === 'polygon') {
      e.target.parentNode.remove();
    }
    this.setLayers();
    this.addToLocalStorage();
  }

  /* draw masking method */
  public mouseUp(e) {
    if(this.pointsFromCamera){
     return;
    } else {
       // if (this.site.analyticId == 7 && this.cam["resolution"] == '1280x720') {
    if (this.cam["resolution"] == '1280x720') {
      if (!this.drawing && e.altKey) {
        this.deleteLayerClick(e);
        return;
      }
      if (this.g) {
        this.addToHistory(this.drawing, this.startPoint, this.g, this.points);
      }
      this.g = this.svg.select('g.drawPoly');
      if (e.button !== 0) { return; }
      if (this.dragging) { return; }
      if (this.previewShown) { return; }
      this.drawing = true;
      this.startPoint = [(e.layerX - this.panzoomModel.pan.x) *
        (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth)),
      (e.layerY - this.panzoomModel.pan.y) *
      (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth))];
      if (this.svg.select('g.drawPoly').empty()) {
        this.g = this.svg.append('g').attr('class', 'drawPoly');
        this.svg.selectAll('circle').attr('cursor', 'default');
      }
      if (e.toElement.tagName === 'circle') {
        this.closePolygon();
        return;
      }
      this.points.push([(e.layerX - this.panzoomModel.pan.x) *
        (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth)),
      (e.layerY - this.panzoomModel.pan.y) *
      (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth))]);
      this.svg.select('g.drawPoly').append('polyline').attr('points', this.points)
        .style('fill', 'none')
        .attr('stroke-width', 1 / (((this.panzoomModel.zoomLevel) <= 1 ? 1 : (this.panzoomModel.zoomLevel)) / 2))
        .attr('stroke', '#000');
      this.svg.select('g.drawPoly').append('circle')
        .attr('cx', this.points[this.points.length - 1][0])
        .attr('cy', this.points[this.points.length - 1][1])
        .attr('r', 4 / (((this.panzoomModel.zoomLevel) <= 1 ? 1 : (this.panzoomModel.zoomLevel)) / 1.5))
        .attr('stroke-width', 1 / (((this.panzoomModel.zoomLevel) <= 1 ? 1 : (this.panzoomModel.zoomLevel)) / 2))
        .attr('fill', this.maskSvc.currentColor.color)
        .attr('stroke', '#000')
        .attr('is-handle', 'true')
        .attr('class', 'inProgressCircle')
        .attr('style', 'cursor:pointer');
    }
    // }
    }
   
  }

  public closePolygon(childPoly?: boolean) {
    let child = '';
    if (childPoly) {
      child = ' child';
    }
    this.svg.selectAll('circle').attr('cursor', 'move');
    this.svg.select('g.drawPoly').remove();
    const g = this.svg.append('g').attr('class', this.maskSvc.currentColor.color + ' completePoly' + child).attr('layerHidden', 'false')
      .attr('color', this.maskSvc.currentColor.color)
      .attr('opacity', this.opacity)
      .attr('visibility', 'visible');
    g.append('polygon')
      .attr('points', this.points)
      .attr('shape-rendering', 'crispEdges')
      .style('fill', this.maskSvc.currentColor.color);
    for (const point of this.points) {
      const holder = this;
      g.selectAll('circles')
        .data([point])
        .enter()
        .append('circle')
        .attr('cx', point[0])
        .attr('cy', point[1])
        .attr('r', 4 / ((this.panzoomModel.zoomLevel) <= 1 ? 1 : (this.panzoomModel.zoomLevel)))
        .attr('stroke-width', 1 / ((this.panzoomModel.zoomLevel) <= 1 ? 1 : (this.panzoomModel.zoomLevel) / 2))
        .attr('fill', '#FDBC07')
        .attr('stroke', '#000')
        .attr('is-handle', 'true')
        .attr('class', 'dragCircle')
        .attr('cursor', 'move')
        .call(d3.drag()
          .on('drag', function () {
            holder.handleDrag(this);
          })
          .on('end', () => {
            this.dragging = false;
            this.addToHistory(this.drawing, this.startPoint, this.g, this.points);
          })
        );
    }
    this.points.splice(0);
    this.drawing = false;
    this.setLayers();
    this.addToLocalStorage();
    this.addToHistory(this.drawing, this.startPoint, this.g, this.points);
  }

  public enableDragging() {
    const holder = this;
    this.svg.selectAll('.dragCircle').call(d3.drag()
      .on('drag', function () {
        holder.handleDrag(this);
      })
      .on('end', () => {
        this.dragging = false;
        this.addToHistory(this.drawing, this.startPoint, this.g, this.points);
      })
    );
  }

  public mouseMove(e) {
    if (!this.drawing) { return; }
    const g = d3.select('g.drawPoly');
    if (e.target.tagName === 'line') { return; }
    if (e.target.className.baseVal === 'inProgressCircle') {
      g.select('line').remove();
      return;
    }
    g.select('line').remove();
    g.append('line')
      .attr('x1', this.startPoint[0])
      .attr('y1', this.startPoint[1])
      .attr('x2', (e.layerX - this.panzoomModel.pan.x) *
        (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth)))
      .attr('y2', (e.layerY - this.panzoomModel.pan.y) *
        (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth)))
      .attr('stroke', '#53DBF3')
      .attr('stroke-width', 1 / (this.panzoomModel.zoomLevel * 1.3));
  }

  public handleDrag(e: any) {
    if(this.pointsFromCamera) {
      return;
    } else {
      if (this.drawing) { return; }
      const newPoints: any = [];
      let circle: any;
      this.dragging = true;
      const poly = d3.select(e.parentNode).select('polygon');
      const circles = d3.select(e.parentNode).selectAll('circle');
  
      if (this.cam["resolution"] == '480x360') {
        if (((d3.event.x) >= 0) && (d3.event.x) <= 480 && (d3.event.y >= 0) && ((d3.event.y) <= 360)) {
          e.setAttribute('cy', d3.event.y);
          e.setAttribute('cx', d3.event.x);
          for (const circleGroup of circles._groups[0]) {
            circle = d3.select(circleGroup);
            newPoints.push([circle.attr('cx'), circle.attr('cy')]);
          }
          poly.attr('points', newPoints);
        }
      }
  
      if (this.cam["resolution"] == '1280x720') {
        if (((d3.event.x) >= 0) && (d3.event.x) <= this.getImageWidth && (d3.event.y >= 0) && ((d3.event.y) <= this.getImageHeight)) {
          e.setAttribute('cy', d3.event.y);
          e.setAttribute('cx', d3.event.x);
          for (const circleGroup of circles._groups[0]) {
            circle = d3.select(circleGroup);
            newPoints.push([circle.attr('cx'), circle.attr('cy')]);
          }
          poly.attr('points', newPoints);
        }
      }
    }
   

  }

  public incrementOpacity(up: boolean): void {
    if (up) {
      this.opacity = Math.min(this.opacity + 20, 100);
    } else {
      this.opacity = Math.max(this.opacity - 20, 0);
    }
    //    this.updateOpacity();
  }



  public updateImage(url?): void {
    if (url) { this.svg.style('background-image', `url('${url}')`); } else {
      this.svg.style('background-image', `url('${this.url.nativeElement.value}')`);
      this.imageNumber.nativeElement.value = this.url.nativeElement.value.match(/[\w-]+\.(png|jpg)/)[0].substring(0, 4);
    }
  }

  public updateImageByNumber(): void {
    this.svg.style('background-image', `url('https://raw.githubusercontent.com/commaai/comma10k/master/imgs/${this.lut.getUrl(this.imageNumber.nativeElement.value.padStart(4, '0'))}')`);
    this.url.nativeElement.value = `https://raw.githubusercontent.com/commaai/comma10k/master/imgs/${this.lut.getUrl(this.imageNumber.nativeElement.value.padStart(4, '0'))}`;
    this.imageNumber.nativeElement.value = this.imageNumber.nativeElement.value.padStart(4, '0');
  }

  onModelChanged(model: PanZoomModel): void {
    if (this.artboard && model.zoomLevel >= 1) {
      this.svg.selectAll('circle').attr('r', 4 / (model.zoomLevel / 1.5));
      this.svg.selectAll('polyline').attr('stroke-width', 1 / (model.zoomLevel / 2));
      this.svg.selectAll('circle').attr('stroke-width', 1 / (model.zoomLevel / 2));
    }
  }

  public addToHistory(drawing, startPoint, g, points): void {
    const collection = this.svgElement.innerHTML;
    this.history.unshift([JSON.stringify(collection), JSON.stringify(drawing),
    JSON.stringify(startPoint), cloneDeep(g), JSON.stringify(points)]);
    if (this.history.length > 15) {
      this.history.pop();
    }
  }

  public addToLocalStorage(): void {
    const collection = this.artboard.nativeElement.innerHTML;
    const contents = JSON.stringify({
      artboard: JSON.stringify(collection),
      url: this.maskSvc.currentUrl,
      opacity: this.opacity
    });
    localStorage.setItem(this.maskSvc.currentUrl, contents);
  }

  public revertFromLocalStorage(collection: string): void {
    this.deleteAllLayers();
    const contents = JSON.parse(collection);
    this.artboard.nativeElement.innerHTML = JSON.parse(contents.artboard);
    this.svg = d3.select('svg');
    this.maskSvc.currentUrl = contents.url;
    this.enableDragging();
    this.setLayers();
    this.loadedMask = this.maskSvc.loadedMask();
    this.svgElement = this.artboard.nativeElement.children[0];
  }

  public undo(): void {
    if (this.history.length > 0) {
      this.svgElement.innerHTML = JSON.parse(this.history[0][0]);
      this.drawing = JSON.parse(this.history[0][1]);
      this.startPoint = JSON.parse(this.history[0][2]);
      this.g = this.history[0][3];
      this.points = JSON.parse(this.history[0][4]);
      this.history.shift();
    }
    this.enableDragging();
  }

  public toFront(i: number) {
    this.svgElement.append(this.svgElement.children[i]);
  }

  public toBottom(i: number) {
    this.svgElement.prepend(this.svgElement.children[i]);
  }

  public updateColor(i: number, color: string) {
    this.svgElement.children[i].children[0].setAttribute('style', 'fill: ' + color + ';');
    this.svgElement.children[i].setAttribute('color', color);
    // TODO update local storage?
  }

  public toggleVisibility(i: number) {
    if (this.svgElement.children[i].getAttribute('visibility') !== 'hidden') {
      this.svgElement.children[i].setAttribute('visibility', 'hidden');
      this.svgElement.children[i].setAttribute('layerHidden', 'true');
      return;
    }
    this.svgElement.children[i].setAttribute('visibility', 'visible');
    this.svgElement.children[i].setAttribute('layerHidden', 'false');
    this.setLayers();
  }

  public toggleAll(): void {
    if (this.svgElement.children.length > 0) {
      if (this.getVisibility(0)) {
        for (const layer of this.svgElement.children) {
          if (layer.classList.contains('completePoly')) {
            layer.setAttribute('visibility', 'hidden');
            layer.setAttribute('layerHidden', 'true');
          }
        }
      } else {
        for (const layer of this.svgElement.children) {
          layer.setAttribute('visibility', 'visible');
          layer.setAttribute('layerHidden', 'false');
        }
      }
    }
  }

  public toggleControlPoints(): void {
    if (this.svgElement.classList.contains('hideCircles')) {
      this.svgElement.classList.remove('hideCircles');
    } else {
      this.svgElement.classList.add('hideCircles');
    }
  }

  public previewExport(): void {
    if (!this.previewShown) {
      if (this.drawing) {
        return;
      }
      this.previewShown = true;
      this.svgToPng.base64ToGit()
        .then(base64 => {
          const g = this.svg.append('g').attr('class', 'existingMask' + ' completePoly' + ' preview').attr('layerHidden', 'false')
            .attr('color', 'existingMask')
            .attr('opacity', (this.opacity > 0.2 ? this.opacity : 0.2))
            .attr('visibility', 'visible');
          g.append('svg:image')
            .attr('href', base64)
            .attr('x', 43)
            .attr('y', 38)
          for (const layer of this.svgElement.children) {
            if (!layer.classList.contains('preview')) {
              layer.setAttribute('visibility', 'hidden');
              layer.setAttribute('layerHidden', 'true');
            }
          }
          this.setLayers();
        });
    } else {
      this.svg.selectAll('.preview').remove();
      this.previewShown = false;
      for (const layer of this.svgElement.children) {
        layer.setAttribute('visibility', 'visible');
        layer.setAttribute('layerHidden', 'false');
      }
      this.setLayers();
    }
  }

  public getVisibility(i: number): boolean {
    if (this.svgElement.children[i].getAttribute('visibility') === 'visible') {
      return true;
    }
    return false;
  }

  public deleteLayer(i: number) {
    if (this.getLayerType(i) === 'Existing Mask') {
      this.loadedMask = false;
    }
    this.svgElement.children[i].remove();
  }

  public deleteAllLayers() {
    if (this.drawing) { return; }
    if (confirm('Warning: This will remove all current layers')) {
      this.svg.selectAll('g').remove();
    }
  }

  public deleteCurrentLayer() {
    if (!this.drawing) { return; }
    this.drawing = false;
    this.startPoint = [];
    this.points = [];
    this.svg.select('g.drawPoly').remove();
  }


  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.code === 'Escape') { this.deleteCurrentLayer(); }
    if (event.code === 'BracketLeft') { this.toggleControlPoints(); }
    if (event.code === 'KeyO') { this.previewExport(); }
    if (event.code === 'KeyZ' && event.ctrlKey === true) { this.undo(); }
    if (event.code === 'Numpad0' || event.code === 'Digit0') { this.panZoomAPI.resetView() }
  }

  public getLayerType(i: number): string {

    const colors = [['#402020 completePoly', 'Road'], ['#ff0000 completePoly', 'Lane Markings'], ['#808060 completePoly', 'Undrivable'],
    ['#00ff66 completePoly', 'Movable'], ['#cc00ff completePoly', 'My Car'], ['existingMask completePoly', 'Existing Mask']];
    for (const color of colors) {
      if (color[0] === this.svgElement.children[i].getAttribute('class')) {
        return color[1];
      }
    }
    return 'In Progress';
  }

  goBack() {
    this.router.navigate(['camera-server/masking']);
  }

  updateMaskData(element){
    this.spinner.activate();
    if(element){
      let camUniqueId = element;
      this.cameraService.updateMaskByUniqId(camUniqueId).subscribe((res:any)=>{
        if(res?.success){
          this.toastr.success(`${res?.data?.charAt(0).toUpperCase() + res?.data.slice(1)}` || 'Masking points updated successfully');
          setTimeout(()=>{
            this.svgElement.innerHTML="";
          this.getMaskAPICall(this.cam);
          },1000)
          this.spinner.deactivate();
        } else {
          this.toastr.warning(`${AppConstants.defaultErrorMessage}`);
          this.spinner.deactivate();
        }
      });
    };
  };

  //changeMasking
  openChangeMaskingModal(cam:any){
    this.camUniqueIdToChange = cam;
    this.modalRef = this.modalService.open(this.changeMaskingModal);
  }
  confirmChangeMasking(): void {
    if (this.camUniqueIdToChange) {
      this.changeMasking(this.camUniqueIdToChange);
      this.modalService.dismissAll('changeMaskingModal');
    }
  }
  changeMasking(camUniqueId: string) {
    this.spinner.activate();
    if (camUniqueId) {
      this.cameraService.changeMaskingByUniqId(camUniqueId).subscribe((res: any) => {
        if(res && res?.success == true){
          this.spinner.deactivate();
          // Show a success message or handle the response as needed
          this.toastr.success('Masking changed successfully');
          setTimeout(() => {
            this.svgElement.innerHTML="";
            this.getMaskAPICall(this.cam);
          }, 1000);
        }
      }, err => {
        if(err){
          this.spinner.deactivate();
          // Show a success message or handle the response as needed
          this.toastr.error('Unable to change masking');
        }
      });
    }
  }
  
  //remove Masking
  removeMaskingModal(cam:any){
    this.camUniqueIdToChange = cam;
    this.modalRef = this.modalService.open(this.removeMaskingModalRef);
  }
  removeMasking(): void {
    if (this.camUniqueIdToChange) {
      this.removeMaskingRef(this.camUniqueIdToChange);
      this.modalService.dismissAll('removeMaskingModalRef');
    }
  }
  removeMaskingRef(camUniqueId: string){
  this.spinner.activate();
  if(camUniqueId){
    this.cameraService.removeMaskingByUniqId(camUniqueId).subscribe((res:any)=>{
      if(res && res.success == true){
        this.spinner.deactivate();
        this.toastr.success('Masking Remove Successfully');
        //this.svg = '';
        setTimeout(() => {
          this.svgElement.innerHTML="";
          this.getMaskAPICall(this.cam);
        }, 1000);
      }
    },(error:any)=>{
      if(error){
        this.toastr.error('Unable to remove masking')
      }
    })
  }
  }

  getMaskAPICall(cam: any){
this.spinner.activate();
var reqParam = {};
this.cameraService.getMasking(cam,reqParam).subscribe((res:any)=>{
if(res){
  let maskData = res?.data?.masking_data;
  let camServerData = res?.data?.cam_server_data;
  let getCamHeight = res?.data?.image_height;
  let getCamWidth = res?.data?.image_width;
  let points_From_Camera = res?.data?.points_from_camera;

  if (maskData != null && maskData != "") {
    cam.maskingData = JSON.parse(maskData);
  }
  else {
    cam.maskingData = [];
  }

  const camData: any = {
    cam: cam,
    site: JSON.parse(sessionStorage.getItem('camdetails'))?.site,
    camServer: camServerData,
    ImageHeight: getCamHeight,
    ImageWidth: getCamWidth,
    Points_From_Camera:points_From_Camera
  }
   sessionStorage.setItem("camdetails", JSON.stringify(camData));

  this.spinner.deactivate();
  this.cam = JSON.parse(sessionStorage.getItem('camdetails'))?.cam;
  this.site = JSON.parse(sessionStorage.getItem('camdetails'))?.site;
  this.camserData = JSON.parse(sessionStorage.getItem('camdetails'))?.camServer;
  this.getImageHeight = JSON.parse(sessionStorage.getItem('camdetails'))?.ImageHeight;
  this.getImageWidth = JSON.parse(sessionStorage.getItem('camdetails'))?.ImageWidth;
  this.pointsFromCamera = JSON.parse(sessionStorage.getItem('camdetails'))?.Points_From_Camera;
  this.addLayer();
}
})
  } 
}
